<div class="container overflow-hidden error-container">
  <div class="row justify-content-md-center">
    <div class="col col-sm-12 col-md-10 col-lg-8 col-xl-6 p-0">

      <div class="container">
        <div class="row content">
          <div class="col-12 p-0">
            <div class="component-header">
              <h3 class="label m-0">{{ 'error.title' | translate }}</h3>
            </div>
          </div>
        </div>
      </div>

      <h4 class="error-text">{{ 'error.text1' | translate }}<br>{{ 'error.text2' | translate }}</h4>

      <app-footer></app-footer>

    </div>
  </div>
</div>
